import * as constants from '../constants/CONSTANT';

const OpportunityProductApi = {
  async searchProducts({ currency, search = '', limit = 25, offset = 0 }) {
    const token = localStorage.getItem('token');

    const params = new URLSearchParams({
      currency: currency || '',
      search,
      limit: String(limit),
      offset: String(offset),
    });

    const response = await fetch(
      `${constants.API_BASE_URL}/api/opportunityproduct/search?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  async createOpportunityProducts({ opportunityId, items, deletedIds = [] }) {
    const token = localStorage.getItem('token');

    const response = await fetch(
      `${constants.API_BASE_URL}/api/opportunityproduct`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          opportunityId,
          items,
          deletedIds,
        }),
      }
    );

    return await response.json();
  },

  async syncProductsFromQuote({ quoteId, opportunityId }) {
    const token = localStorage.getItem('token');

    const response = await fetch(
      `${constants.API_BASE_URL}/api/opportunityproduct/sync-from-quote`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          quoteId,
          opportunityId,
        }),
      }
    );

    return await response.json();
  },
};

export default OpportunityProductApi;
